import {StoreClass, StoreObject} from "../../../stem-core/state/Store.js";
import {field} from "../../../stem-core/state/StoreField.js";
import {Merchant} from "../MerchantStore";
import {MerchantSDKSettings} from "../merchant/MerchantSDKSettingsStore";
import {StemDate} from "../../../stem-core/time/Date";

export class MerchantSDKResource extends StoreObject {
    static dependencies = ["Merchant", "MerchantSDKSettings"];
    static comparator = (a: MerchantSDKResource, b: MerchantSDKResource) => b.lastEditedAt.valueOf() - a.lastEditedAt.valueOf();

    @field("Merchant") merchant: Merchant;
    @field(String) alias: string;
    @field(String) name: string;
    @field(String) description: string;
    @field(Date) createdAt: StemDate;
    @field(Date) lastEditedAt: StemDate;

    @field(Number) settingsVersionId: number;
    @field("MerchantSDKSettings") settingsVersion: MerchantSDKSettings; // TODO @cleanup rename to version?
    @field("self") versionParent: MerchantSDKResource; // Matching resource from previous version. Named like this to distinguish from inheritance along the same version (from base panel for instance)
    declare versionParentId: string;

    @field(Object) options: Record<string, any>;
    @field(Object) dashboardOptions: Record<string, any>;

    toString(): string {
        return this.name;
    }

    get parent(): MerchantSDKResource {
        return this.versionParent;
    }

    get parentId(): string {
        return this.versionParentId;
    }

    allHistoricVersions(maxLength = 10): MerchantSDKResource[] {
        let result: MerchantSDKResource[] = [];
        let currentVersion = this.parent;
        while (currentVersion && result.length < maxLength) {
            result.push(currentVersion);
            currentVersion = currentVersion.parent;
        }
        return result;
    }

    // Return an array of all resources with the same version (implicitly with same merchant).
    allWithSameVersion(): MerchantSDKResource[] {
        return this.getStore().filterBy({settingsVersionId: this.settingsVersionId});
    }

    // Return if there is a resource that is based on the current on in settingsVersion
    getFork(settingsVersion: any): MerchantSDKResource | null {
        return this.getStore().findBy({settingsVersion, versionParent: this});
    }

    // If settingsVersion is null, it's considered we want the master version of the alias
    static getByIdOrAlias<T extends MerchantSDKResource>(this: StoreClass<T>, idOrAlias: string, settingsVersion?: any): T | null {
        const objFromId = this.get(idOrAlias);
        if (objFromId) {
            return objFromId;
        }
        if (settingsVersion) {
            return this.findBy({alias: idOrAlias, settingsVersion});
        }
        return this.find(obj => obj.alias === idOrAlias && obj.settingsVersion?.isMaster);
    }
}
